module.exports={author:"Dara Wier",date:"10/10/2019",publishDate:"10/10/2019",highlighted:!1,tags:"",title:"5x5"};